<div class="tw-flex tw-flex-col tw-gap-1">
  @if (label) {
    <div
      class="tw-flex tw-gap-1 tw-text-dt-text-tertiary tw-z-10 tw-text-[12px]"
      [ngClass]="{ 'tw-font-bold': boldLabel }"
    >
      <span class="tw-whitespace-nowrap">{{ label }}</span>
      <span *ngIf="isRequired" class="tw-text-sm">*</span>
    </div>
  }
  <div
    [class]="compact ? '' : customShadowClass"
    [ngClass]="{
      'input-error-border hover:tw-border-color-status-error focus-within:tw-border-color-status-error':
        (isInvalid() || hasError) && !isDisabled,
      'tw-cursor-text': !isDisabled,
      'tw-cursor-not-allowed tw-opacity-50': isDisabled,
      'tw-h-[24px] tw-rounded tw-px-2 tw-bg-color-surface-input tw-shadow-elevation-input': compact,
      'tw-rounded-xl tw-px-6 tw-py-4 tw-bg-color-surface-input': !compact,
      'tw-h-12': !compact && !multiline,
      'tw-h-24': !compact && multiline,
      'tw-flex tw-items-center': compact || !!prefix || !!suffix,
      'tw-gap-1': !!prefix || !!suffix,
    }"
    class="tw-w-full"
    (mousedown)="handleWrapperMouseDown($event)"
    (click)="!isDisabled && handleWrapperClick()"
  >
    @if (prefix) {
      <span [attr.id]="prefixId" class="tw-text-sm tw-text-dt-text-tertiary tw-shrink-0">{{
        prefix
      }}</span>
    }
    @if (multiline) {
      <textarea
        #inputElement
        class="tw-resize-none tw-bg-transparent tw-border-none tw-cursor-text"
        [ngClass]="{
          'tw-text-sm': compact,
          'tw-form-field-text': !compact,
          'tw-flex-1 tw-self-stretch': prefix || suffix,
          'tw-w-full tw-h-full': !prefix && !suffix,
          '!tw-text-dt-text-secondary': isDisabled,
        }"
        [name]="label"
        [formControl]="formControl"
        [placeholder]="placeholder"
        [attr.aria-describedby]="prefix && label ? prefixId : null"
        [attr.data-testid]="testId"
        (focus)="onFocus()"
        (blur)="onBlur()"
      ></textarea>
    } @else {
      <input
        #inputElement
        class="tw-bg-transparent tw-border-none tw-cursor-text"
        [ngClass]="{
          'tw-text-sm': compact,
          'tw-form-field-text': !compact,
          'tw-flex-1 tw-min-w-0': prefix || suffix,
          'tw-w-full': !prefix && !suffix,
          '!tw-text-dt-text-secondary': isDisabled,
        }"
        [name]="label"
        [type]="type"
        [formControl]="formControl"
        [placeholder]="placeholder"
        [value]="value"
        [attr.aria-describedby]="prefix && label ? prefixId : null"
        [attr.data-testid]="testId"
        (focus)="onFocus()"
        (blur)="onBlur()"
      />
    }
    @if (suffix) {
      <span class="tw-text-sm tw-text-neutral-500 tw-shrink-0">{{ suffix }}</span>
    }
  </div>
  @if (isInvalid() && !isDisabled && !compact) {
    <span class="tw-whitespace-nowrap tw-text-dt-text-error tw-text-xs">{{
      (formControl.errors?.min ? "amountMustBePositive" : "thisFieldIsRequired") | i18n
    }}</span>
  }
</div>
